import { render, staticRenderFns } from "./Deal.vue?vue&type=template&id=da42b5f6&scoped=true&"
import script from "./Deal.vue?vue&type=script&lang=js&"
export * from "./Deal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da42b5f6",
  null
  
)

export default component.exports